import React from 'react';
const Icon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"
        {...props}>
        <path d="M31.9997 58.6668C46.7273 58.6668 58.6663 46.7278 58.6663 32.0002C58.6663 17.2726 46.7273 5.3335 31.9997 5.3335C17.2721 5.3335 5.33301 17.2726 5.33301 32.0002C5.33301 46.7278 17.2721 58.6668 31.9997 58.6668Z"
            stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M32 21.3335V32.0002" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M32 42.6665H32.0267" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
export default Icon;